<template>
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12" text="true" headerTitle="true" :title="t('Add/Edit Condiment')">
                <div class="row g-xl-5 g-3">
                    
                    <addcondiment />
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import { condimentListLanguage } from '@/core/locales/condiment-list-language';

const { t } = useI18n({
  messages: condimentListLanguage
});

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const addcondiment = defineAsyncComponent(() => import("@/components/theme/ecommerce/condimentadd/addcondiment.vue"))
</script>